import { createAdminBondRequestPreviews } from "./AdminBondRequestPreviews";

export const AdminBondRequestPreviewsClosed = createAdminBondRequestPreviews(
	"admin_bond_requests_closed_v2",
	({ status }) => status === "closed" || status === "declined",
);
